"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _components = require("@insided/shared/services/algolia/components");

var _SuggestedTopicsListContainer = _interopRequireDefault(require("./SuggestedTopicsListContainer"));

var _SearchBox = _interopRequireDefault(require("./SearchBox"));

var _algolia = require("@insided/shared/services/algolia");

var _algoliaService = require("../../services/algoliaService");

var _utils = require("@insided/destination/modules/Search/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-suggestion';
exports.cssAnchorName = cssAnchorName;

var TopicSuggestion = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicSuggestion, _Component);

  var _super = _createSuper(TopicSuggestion);

  function TopicSuggestion(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicSuggestion);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hideSuggestions: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var searchClient;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                searchClient = _context.sent;

                _this.setState({
                  searchClient: searchClient,
                  clientId: data.client_id,
                  token: data.token,
                  hiddenCategories: data.hiddenCategories
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.communityId = (0, _utils.getCommunityId)();
    return _this;
  }

  (0, _createClass2.default)(TopicSuggestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _algoliaService.getSearchToken)(this.cb);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          clientId = _this$state.clientId,
          token = _this$state.token,
          hiddenCategories = _this$state.hiddenCategories,
          hideSuggestions = _this$state.hideSuggestions,
          searchClient = _this$state.searchClient;
      var _this$props = this.props,
          hosts = _this$props.hosts,
          defaultCdn = _this$props.defaultCdn;
      if (!searchClient) return null;
      return (0, _preact.h)("div", {
        className: "topic-create_suggestions-wrapper"
      }, (0, _preact.h)(_components.InstantSearch, {
        searchClient: searchClient,
        indexName: this.communityId
      }, (0, _preact.h)(_components.Configure, {
        hitsPerPage: 7,
        analyticsTags: ['destination', 'topic creation suggestion'],
        filters: (0, _utils.getFilters)({
          hiddenCategories: hiddenCategories
        })
      }), (0, _preact.h)(_SearchBox.default, {
        defaultCdn: defaultCdn,
        hideSuggestionsCallback: function hideSuggestionsCallback(value) {
          return _this2.setState({
            hideSuggestions: value
          });
        }
      }), !hideSuggestions && (0, _preact.h)(_SuggestedTopicsListContainer.default, null)));
    }
  }]);
  return TopicSuggestion;
}(_preact.Component);

var _default = TopicSuggestion;
exports.default = _default;